import styled from "styled-components";
import { Box as MuiBox, Button as MuiButton } from "@mui/material";

export const Button = styled(MuiButton)`
  &.MuiButton-root{
    display: flex;
    flex-direction: row;
    align-items: baseline;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    padding:10px 24px;
    border: none;
    border-radius: 100px;
    min-width: unset;
    min-height:unset;
    text-transform: none;
  }

  &.outlined, &.outlined:hover{
    color: #6750A4;
    border: 1px solid #6750A4;
    background-color: #FFFFFF;
  }

  &.contained, &.contained:hover{
    color: #FFFFFF;
    border: 1px solid #6750A4;
    background-color: #6750A4;
  } 

  &.standard, &.standard:hover{
    color: #FFFFFF;
    border: 1px solid #6750A4;
    background-color: #535353;
  }

  &.text, &.text:hover {
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: #6750A4;
    border: none;
    background-color: transparent;
    padding:5px;
  }

  &.disabled {
    color: #FFFFFF !important;
    border: 1px solid #B4B4B4;
    background-color: #B4B4B4;
  }

  &.text.disabled, &.text.disabled:hover {
    color: #B4B4B4 !important;
    border: none;
    background-color: transparent;
  }
`;

export const Wrap = styled(MuiBox)`
  &.MuiBox-root {
    display:flex;
    justify-content: center;
    align-items:center;
    width: 100%;
    height: 100px;
    gap: 16px;
  }
`;
